import {createEntityService} from 'utils/createEntityService';
import {Role} from 'types/role';

export const RoleService = createEntityService<Role>({
  baseUrl: 'api/v1/roles',
  entityName: 'role',
});
